import { useAxiosInstance } from './axiosInstance';

// Save FCM token
export const saveFCMToken = async (token: string, deviceInfo: any, axiosInstance: any) => {
  const instance = await axiosInstance;
  const response = await instance.post(
    '/notifications/fcm-token',
    { token, deviceInfo }
  );
  return response.data;
};

// Get user notifications
export const getNotifications = async (axiosInstance: any, params?: {
  limit?: number;
  offset?: number;
  seen?: boolean;
  notificationType?: string;
}) => {
  const instance = await axiosInstance;
  const response = await instance.get('/notifications', { params });
  return response.data;
};

// Mark notification as seen
export const markNotificationAsSeen = async (notificationId: number, axiosInstance: any) => {
  const instance = await axiosInstance;
  const response = await instance.patch(`/notifications/${notificationId}/seen`, {});
  return response.data;
};

// Delete FCM token (for logout)
export const deleteFCMToken = async (token: string, axiosInstance: any) => {
  const instance = await axiosInstance;
  const response = await instance.delete('/notifications/fcm-token', {
    data: { token }
  });
  return response.data;
};

// Admin endpoints
export const getNotificationsAdmin = async (axiosInstance: any, params?: {
  orgId?: string;
  userId?: string;
  notificationType?: string;
  languageSent?: string;
  seen?: boolean;
  startDate?: string;
  endDate?: string;
  limit?: number;
  offset?: number;
}) => {
  const instance = await axiosInstance;
  const response = await instance.get('/notifications/admin/notifications', { params });
  return response.data;
};

// Send manual notification (admin only)
export const sendManualNotification = async (
  data: {
    recipients: string[] | 'all' | { role: string } | { orgId: string };
    notificationType: string;
    title: string;
    body: string;
    metadata?: any;
  },
  axiosInstance: any
) => {
  const instance = await axiosInstance;
  const response = await instance.post('/notifications/admin/notifications/send', data);
  return response.data;
};

// Test background notification
export const testBackgroundNotification = async (axiosInstance: any) => {
  const instance = await axiosInstance;
  const response = await instance.post('/notifications/test/background', {});
  return response.data;
};